import React, {cloneElement, Children, isValidElement} from 'react';
import PropTypes from 'prop-types';
import styles from './action-menu.module.scss';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  closeMenu: PropTypes.func,
};

const ActionMenu = ({children, closeMenu}) => {
  const childrenWithCloseMenu = Children.map(children, (child) =>
    isValidElement(child) ? cloneElement(child, {closeMenu}) : child
  );
  return <ul className={styles.menu}>{childrenWithCloseMenu}</ul>;
};

ActionMenu.propTypes = propTypes;

export default ActionMenu;
